import { render, staticRenderFns } from "./Screenfull.vue?vue&type=template&id=084fce8d&scoped=true&"
import script from "./Screenfull.vue?vue&type=script&lang=js&"
export * from "./Screenfull.vue?vue&type=script&lang=js&"
import style0 from "./Screenfull.vue?vue&type=style&index=0&id=084fce8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084fce8d",
  null
  
)

export default component.exports